var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#E0F4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9091 20.1818C30.6591 20.1818 30.2053 23.4545 29.2273 23.4545C28.2493 23.4545 28.8182 20.1818 27.7955 20.1818C26.5682 20.1818 25.1364 25.0909 21.8636 25.0909C20.6364 25.0909 20.6364 22.7067 20.6364 20.3864C20.6364 18.0661 21.4545 16.9091 22.4773 16.9091C23.5 16.9091 23.9091 17.7401 23.9091 18.5455C23.9091 21.8182 18.1818 25.0909 14.0909 25.0909C12.1413 25.0909 10.8182 21.0447 10.8182 18.5455C10.8182 14.4545 12.4545 12 14.9091 12C16.75 12 17.3636 13.9624 17.3636 15.4773C17.3636 23.0455 10.4091 26.9318 10.4091 26.9318M10 30H32.9091",
    stroke: "#00A3FA",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignedIcon);
export default __webpack_public_path__ + "static/media/signed-icon.179497a06f863761b5060f6d5106a94c.svg";
export { ForwardRef as ReactComponent };